// auth.guard.ts

import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
  CanActivateFn,
} from "@angular/router";
import { AuthService } from "../_services/auth.service";
import { Observable } from "rxjs";
import { LocalStorageService } from "../_services/localStorage.service";
import { needsPhoneCompletion } from "../helpers/phone-helper";
import { needsProfileCompletion } from "../helpers/profile-helper";
@Injectable({
  providedIn: "root",
})
class authentificationService {
  constructor(
    private authService: AuthService,
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const status = next.data["status"] as boolean;
    let result;
    const userData = this.localStorageService.getUserData().client;
    if (userData && needsProfileCompletion(userData)) {
      if (!status) {
        return true;
      }
      this.router.navigate(["/"]);
      return false;
    }
    if (userData && needsPhoneCompletion(userData)) {
      // Allow login route to render so the forced phone modal can appear there.
      if (!status) {
        return true;
      }
      // Prevent direct access to protected areas until phone is completed.
      this.router.navigate(["/"]);
      return false;
    }

    if (userData) {
      result = status;
    } else {
      // Do not navigate away: `/` is LoginPage and OAuth redirect returns here;
      // navigating would strip the callback URL before Firebase can finish sign-in.
      result = !status;
    }
    if (!result) {
      if (status) {
        this.router.navigate(["/"]);
      } else {
        this.router.navigate(["/prestataire"]);
      }
    }

    return result;
  }
}
export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  return inject(authentificationService).canActivate(next, state);
};
